import React from 'react';

const AccountStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8 transform-gpu transition-medium hover:scale-[1.005]">
      {/* Servers Tested Card */}
      <div className="bg-dark-600 rounded-2xl p-5 border border-dark-400 hover:border-accent-green/30 transition-medium transform-gpu hover:-translate-y-1 hover:shadow-md">
        <h4 className="text-gray-400 text-sm mb-2 group-hover:text-white transition-medium">Servers Tested</h4>
        <p className="text-3xl font-bold group-hover:text-accent-green transition-medium">{stats.serversTested}</p>
        <div className="flex items-center mt-1">
          <span className="text-accent-green text-xs group-hover:text-white transition-medium">{stats.serversTestedChange}</span>
        </div>
        <div className="absolute bottom-3 right-3 w-8 h-8 rounded-full bg-accent-green/10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-medium">
          <i className="fas fa-server text-accent-green text-xs"></i>
        </div>
      </div>
      
      {/* Bonus Points Card */}
      <div className="bg-dark-600 rounded-2xl p-5 border border-dark-400 hover:border-accent-blue/30 transition-medium transform-gpu hover:-translate-y-1 hover:shadow-md">
        <h4 className="text-gray-400 text-sm mb-2 group-hover:text-white transition-medium">Bonus Points</h4>
        <p className="text-3xl font-bold group-hover:text-accent-blue transition-medium">{stats.bonusPoints}</p>
        <div className="flex items-center mt-1">
          <span className="text-accent-blue text-xs group-hover:text-white transition-medium">{stats.bonusPointsChange}</span>
        </div>
        <div className="absolute bottom-3 right-3 w-8 h-8 rounded-full bg-accent-blue/10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-medium">
          <i className="fas fa-coins text-accent-blue text-xs"></i>
        </div>
      </div>
      
      {/* Tests Remaining Card */}
      <div className="bg-dark-600 rounded-2xl p-5 gradient-border premium-glow transform-gpu hover:-translate-y-1 hover:shadow-lg hover:shadow-accent-purple/20 transition-medium">
        <h4 className="text-gray-400 text-sm mb-2 group-hover:text-white transition-medium">Tests Remaining</h4>
        <p className="text-3xl font-bold gradient-text-premium group-hover:animate-pulse-text">{stats.testsRemaining}</p>
        <div className="flex items-center mt-1">
          <span className="text-accent-purple text-xs group-hover:text-white transition-medium">Resets in 21 days</span>
        </div>
        <div className="absolute bottom-3 right-3 w-8 h-8 rounded-full bg-accent-purple/10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-medium">
          <i className="fas fa-bolt text-accent-purple text-xs"></i>
        </div>
      </div>
      
      {/* Successful Hacks Card */}
      <div className="bg-dark-600 rounded-2xl p-5 border border-dark-400 hover:border-accent-pink/30 transition-medium transform-gpu hover:-translate-y-1 hover:shadow-md">
        <h4 className="text-gray-400 text-sm mb-2 group-hover:text-white transition-medium">Successful Hacks</h4>
        <p className="text-3xl font-bold group-hover:text-accent-pink transition-medium">{stats.successfulHacks}</p>
        <div className="flex items-center mt-1">
          <span className="text-accent-purple text-xs group-hover:text-white transition-medium">{stats.successRate} success rate</span>
        </div>
        <div className="absolute bottom-3 right-3 w-8 h-8 rounded-full bg-accent-pink/10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-medium">
          <i className="fas fa-shield-alt text-accent-pink text-xs"></i>
        </div>
      </div>
    </div>
  );
};

export default AccountStats;